import ImagesAuthenticationResetPasswordForgotPasswordBackgroundWebp from '@/public/images/authentication/reset-password/forgot-password-background.webp';
import ImagesAuthenticationResetPasswordResetPasswordSuccessSvg from '@/public/images/authentication/reset-password/reset-password-success.svg';
import ImagesAuthenticationResetPasswordWhiskyDecanterSecurityRenewalWebp from '@/public/images/authentication/reset-password/whisky-decanter-security-renewal.webp';

export {
  ImagesAuthenticationResetPasswordForgotPasswordBackgroundWebp,
  ImagesAuthenticationResetPasswordResetPasswordSuccessSvg,
  ImagesAuthenticationResetPasswordWhiskyDecanterSecurityRenewalWebp,
};
